// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"edc3642e","400":"dc21ec49","453":"b9a9c139","732":"4b4d04dc"}[chunkId] + ".chunk.js";
};